import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, createBlock as _createBlock, KeepAlive as _KeepAlive } from "vue"

const _hoisted_1 = {
  class: "wdw-news-project",
  ref: "projectEl"
}
const _hoisted_2 = {
  key: 0,
  class: "pt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Message = _resolveComponent("Message")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.errorMsg.content !== '')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_Message, {
            severity: $setup.errorMsg.severity,
            closeable: true
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($setup.errorMsg.content), 1)
            ]),
            _: 1
          }, 8, ["severity"])
        ]))
      : _createCommentVNode("", true),
    (_openBlock(), _createBlock(_KeepAlive, null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent($setup.currentComponent.name), _mergeProps($setup.currentComponent.props, { onScrollIntoView: $setup.onScrollIntoView }), null, 16, ["onScrollIntoView"]))
    ], 1024))
  ], 512))
}